import React from 'react'
import { ReportType } from './index.type'
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

interface ReportTableProps {
  reportList: ReportType[]
}

const ReportTable = ({ reportList }: ReportTableProps) => {
  const { t, i18n } = useTranslation();
  return (
    <div className='px-8'>
      {reportList.length === 0
        ? <div className='flex justify-center items-center h-12 text-sm text-gray-500'>{t('categManagement.noReportsAvailable')}</div>
        : <div>
            {/* Table Header */}
            <div className="px-1 py-3 discovery-accordion-grid text-sm border-b border-gray-300 text-gray-500 font-semibold">
              <div className="discovery-accordion-cell truncate">
                {t("reportManagement.table.titleName")}
              </div>
              <div className="discovery-accordion-cell truncate">
                {t("reportManagement.table.titleDescription")}
              </div>
              <div className="discovery-accordion-cell"></div>
              <div className="discovery-accordion-cell"></div>
            </div>

            {/* Report Rows */}
            {reportList.map((report: ReportType, index: number) => (
              <div
                key={report.id}
                className={`px-1 discovery-accordion-grid items-start min-h-[48px] ${
                  index < reportList.length - 1 ? 'border-b border-gray-300' : ''
                }`}
              >
                {/* Report Name */}
                <div className="discovery-accordion-cell">
                  <Tooltip placement="top" title={i18n.language === 'fr' ? report.nameFr : report.nameEn} color='#4d4c4c'>
                    <span className="text-sm text-gray-600 break-words line-clamp-2 block">
                      {i18n.language === 'fr' ? report.nameFr : report.nameEn}
                    </span>
                  </Tooltip>
                </div>

                {/* Report Description */}
                <div className="discovery-accordion-cell">
                  <Tooltip placement="top" title={i18n.language === 'fr' ? report.descriptionFr : report.descriptionEn} color='#4d4c4c'>
                    <span className="text-sm text-gray-600 break-words line-clamp-2 block">
                      {i18n.language === 'fr' ? report.descriptionFr : report.descriptionEn}
                    </span>
                  </Tooltip>
                </div>

                {/* Empty columns to match grid */}
                <div className="discovery-accordion-cell"></div>
                <div className="discovery-accordion-cell"></div>
              </div>
            ))}
          </div>
      }
    </div>)
}

export default ReportTable

